/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypeTextIcon16Light } from './FileTypeTextIcon16Light';
import { FileTypeTextIcon16Regular } from './FileTypeTextIcon16Regular';
import { FileTypeTextIcon16Solid } from './FileTypeTextIcon16Solid';
import { FileTypeTextIcon20Light } from './FileTypeTextIcon20Light';
import { FileTypeTextIcon20Regular } from './FileTypeTextIcon20Regular';
import { FileTypeTextIcon20Solid } from './FileTypeTextIcon20Solid';
import { FileTypeTextIcon24Regular } from './FileTypeTextIcon24Regular';
import { FileTypeTextIcon24Solid } from './FileTypeTextIcon24Solid';
import { FileTypeTextIcon32Regular } from './FileTypeTextIcon32Regular';
import { FileTypeTextIcon64Regular } from './FileTypeTextIcon64Regular';
var sizes = {
    16: {
        light: FileTypeTextIcon16Light,
        regular: FileTypeTextIcon16Regular,
        solid: FileTypeTextIcon16Solid,
    },
    20: {
        light: FileTypeTextIcon20Light,
        regular: FileTypeTextIcon20Regular,
        solid: FileTypeTextIcon20Solid,
    },
    24: {
        regular: FileTypeTextIcon24Regular,
        solid: FileTypeTextIcon24Solid,
    },
    32: {
        regular: FileTypeTextIcon32Regular,
    },
    64: {
        regular: FileTypeTextIcon64Regular,
    },
};
export var FileTypeTextIcon = forwardRef('FileTypeTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
